'use client';

import { useOrderReceivedData } from '@/ui/providers/order-received-data-provider';

/**
 * The `order-summary` tile is a placement slot. The summary is an async server component
 * (OrderConfirmationSummary) rendered upstream in page.tsx and handed down through the order-received
 * context as `summaryContent`, because the generic client-side TileRenderer can't render an async
 * server component itself. This tile just drops that pre-rendered node into place.
 */
export function ConfirmationPageOrderSummary() {
  const summaryContent = useOrderReceivedData()?.summaryContent;

  return summaryContent ?? null;
}
